<!-- =========================================================================================
Martin vicencio
========================================================================================== -->

<style>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
</style>

<template>
    <vx-card  title="" code-toggler>

  <div v-if="abrir_parametro_generar_horario>0">
     <!-- Esta activo el periodo  para generar horarios. -->

      <div class="vx-row" >
        <!-- CARD 9: DISPATCHED ORDERS -->
          <vx-card  style="margin: 20px;" title="Asignar Grupos a Horarios">
          <div style="margin: 10px;" class="vx-row lg:flex-row">
                 <div class="col-4">
                 <h4><b>Seleccione una Carrera
                  <!-- <v-select @change="onChangenGrupof(cuatrimestre_select.nGrupof)" style="width: 200px;" label="nGrupof" v-model="cuatrimestre_select"  :options="cuatrimestres_digitos_periodo">
                  </v-select>   @change="onChangeCarreraList($event)" -->
                    <v-select @change="onChangeCarreraList(carreraListSelected.id)" style="width: 400px;" label="nombre"  placeholder="select"  v-model="carreraListSelected" :options="carreras">
                       <!-- <option value="0">select</option> -->
                  
                    </v-select>

                   <!-- <v-select  style="width: 400px;" label="nombre" v-model="carreraListSelected" :options="carreras"></v-select> -->



                   </b></h4> 
                   <!-- {{carreraListSelected.id}} -->
            </div>
            <div class="col-3">
                 <h4><b>{{cuatrimestre_siguiente[0].nombre}} {{cuatrimestre_siguiente[0].idAgno}} 
                  <v-select @change="onChangenGrupof(cuatrimestre_select.nGrupof)" style="width: 200px;" label="nGrupof" v-model="cuatrimestre_select"  :options="cuatrimestres_digitos_periodo"></v-select>
                      </b></h4> 
             </div>
                         
             <div class="col-2">
                               <vs-button  color="primary" style="margin-left: 60px;" icon-pack="feather"  icon="icon-printer" size="45px" @click="printpage()"></vs-button>
                               </div>
                             
             
          </div>               
            
          </vx-card>

      </div>
<br/>

      <div class="">
        <vs-popup style="" class="holamundo"  title="Asignar grupo:" :active.sync="popupActive">
          <vx-card title="" code-toggler>
            <p>Elija un grupo para el horario seleccionado:
              <v-select label="datos_grupo" v-model="grupo_select" :options="grupos_cuatrimestre_digito"></v-select>
            </p>
          </vx-card><br/>
          <p style="margin: 10px;">

            <vs-button style="margin: 2px;" class="float-right"  @click="guardar_materia_horario()">Asignar</vs-button>
            <vs-button color="danger" type="filled" style="margin: 2px;"  class="float-right"  @click="quitar_materia_horario()">Quitar Grupo</vs-button>
          </p>
        </vs-popup>
      </div>


      <div class="vx-row">

        <!-- CARD 4: SESSION -->

        <!-- CARD 5: SUPPORT TRACKER -->

          <vx-card title="Horario Grupos" id="printContent">
              
            <!-- CARD ACTION -->

            <div class="row">
              <span style="text-align: center;"><h1>{{nGrupof_text}}</h1>
              <br>
              <h4><b>{{cuatrimestre_siguiente[0].nombre}} {{cuatrimestre_siguiente[0].idAgno}} </b></h4>
              </span>
              
              <div class="col">
                <div class="table-responsive">
                  <table class="table" style="width:90%;  margin-left: 30px;">
                    <thead>
                    <th></th>
                    <!-- <th v-for="dia in dias_horarios">{{dia.dia}}</th> -->
            <th   style="text-align: center;" v-for="dia in dias_horarios" :key="dia.dia">{{dia.dia}}</th>
                    </thead>
                    <tbody style="">
                    <tr  v-for="hora in horas_horarios" :key="hora.id">
                      
                      <td style="width: 150px; text-align: right"><strong>{{hora.horario}}</strong></td>
                      <!-- lunes      -->
                      <td  style=" text-align: center;">                       
                           <div v-if="get_clave(1,hora.id)=='Libre'">
                                       <vs-button  id="ocultar_impresion" @click="asignar_horario(1,hora.id)" style="font-size: 12px; width: 100px; height: 30px; padding: 2px;text-align: center;" color="success"> 
                                        <b>  {{get_clave(1,hora.id)}} </b>
                                       </vs-button>
                            </div> 
                           <div v-else >
                            <vs-button @click="asignar_horario(1,hora.id)" style="font-size: 12px; width: 180px; height: 30px; padding: 2px;text-align: center;" color="danger"> 
                             <!-- <b> {{get_clave(1,hora.id)}} </b> -->
                             <font color="black"><b> {{get_clave(1,hora.id)}}  </b></font>
                             </vs-button>             
                           </div>  
                     </td>


           <!-- mart      -->
                    <td style=" text-align: center;">                       
                           <div v-if="get_clave(2,hora.id)=='Libre'">
                                       <vs-button id="ocultar_impresion" @click="asignar_horario(2,hora.id)" style="font-size: 12px; width: 100px; height: 30px; padding: 2px;text-align: center;" color="success"> 
                                        <b> {{get_clave(2,hora.id)}} </b>
                                       </vs-button>
                            </div> 
                           <div v-else >
                            <vs-button @click="asignar_horario(2,hora.id)" style="font-size: 12px; width: 180px; height: 30px; padding: 2px;text-align: center;" color="danger"> 
                             <!-- <b> {{get_clave(2,hora.id)}} </b> -->
                             <font color="black"><b> {{get_clave(2,hora.id)}}  </b></font>
                             </vs-button>             
                          </div>  
                     </td>
  <!-- mier      -->
                      <td style="text-align: center;">                       
                           <div v-if="get_clave(3,hora.id)=='Libre'">
                                       <vs-button  id="ocultar_impresion" @click="asignar_horario(3,hora.id)" style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                        <b> {{get_clave(3,hora.id)}} </b>
                                       </vs-button>
                            </div> 
                           <div v-else >
                            <vs-button @click="asignar_horario(3,hora.id)" style="font-size: 12px; width: 180px; height: 30px; padding: 2px;text-align: center;" color="danger"> 
                              <!-- <b>{{get_clave(3,hora.id)}} </b> -->
                              <font color="black"><b> {{get_clave(3,hora.id)}}  </b></font>
                             </vs-button>             
                         </div>  
                     </td>
  <!-- juev      -->
                      <td style=" text-align: center;">                       
                           <div v-if="get_clave(4,hora.id)=='Libre'">
                                       <vs-button  id="ocultar_impresion" @click="asignar_horario(4,hora.id)" style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                       <b>  {{get_clave(4,hora.id)}} </b>
                                       </vs-button>
                            </div> 
                           <div v-else >
                            <vs-button @click="asignar_horario(4,hora.id)" style="font-size: 12px; width: 180px; height: 30px;  padding: 2px;text-align: center;" color="danger"> 
                              <!-- <b>{{get_clave(4,hora.id)}} </b> -->
                              <font color="black"><b> {{get_clave(4,hora.id)}}  </b></font>
                             </vs-button>             
                         </div>  
                     </td>

  <!-- vier      -->

                          <td style=" text-align: center;">                       
                           <div v-if="get_clave(5,hora.id)=='Libre'">
                                       <vs-button id="ocultar_impresion" @click="asignar_horario(5,hora.id)" style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                       <b>  {{get_clave(5,hora.id)}} </b>
                                       </vs-button>
                            </div> 
                           <div v-else >
                            <vs-button @click="asignar_horario(5,hora.id)" style="font-size: 12px; width: 180px; height: 30px;  padding: 2px;text-align: center;" color="danger"> 
                              <!-- <b>{{get_clave(5,hora.id)}} </b> -->
                              <font color="black"><b> {{get_clave(5,hora.id)}}  </b></font>
                             </vs-button>             
                         </div>  
                     </td>
  <!-- sab      -->

                      <td style=" text-align: center;">                       
                           <div  v-if="get_clave(6,hora.id)=='Libre'">
                                       <vs-button id="ocultar_impresion" @click="asignar_horario(6,hora.id)" style="font-size: 12px; width: 100px; height: 30px;  padding: 2px;text-align: center;" color="success"> 
                                      <b>  {{get_clave(6,hora.id)}}  </b>
                                     
                                       </vs-button>
                            </div> 
                           <div v-else >
                            <vs-button @click="asignar_horario(6,hora.id)" style="font-size: 12px; width: 180px; height: 30px; padding: 2px;text-align: center;" color="danger"> 
                              <font color="black"><b> {{get_clave(6,hora.id)}}  </b></font>
                             </vs-button>             
                         </div>  
                     </td>
                  
                    </tr>

                    </tbody>
                  </table>
                </div>



              </div>
            </div>

          </vx-card>


      </div>

 </div>
<div v-else>
  Esta cerrado el pediodo para generar horarios.
</div>

    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import Button from "@/views/components/vuesax/button/Button";
import Table from "@/views/ui-elements/table/Table";
    export default {
        data() {
          return {

            id_rol: this.getKey('id_rol'),
            // carrera: localStorage.getItem('id_carrera'),
            carrera:0,
            cuatrimestre_siguiente: [{ nombre: "", idAgno: "" }],
            horario: [],
            cuatrimestres_digitos_periodo: [],
            grupo_elegido: [],
            carreras: [],
            carreraListSelected:'',
            horas_horarios:[{hora:''}],
            dias_horarios:[{dia:''}],
            cuatrimestre_select:[],
            tabla_horarios:[],
            popupActive: false,
            grupos_cuatrimestre_digito: [],
            grupo_select:[],
            nGrupof_text:"",
             abrir_parametro_generar_horario:{}

          }
        },
        created(){

        if(this.id_rol == 6){
          this.$vs.loading();
          // this.carrera = localStorage.getItem('id_carrera');
          this.getCarreras();
          this.getCuatrimestreSiguente();
           this.open_generar_horario();
              
        }

        },
        mounted(){

        },
        watch: {
       
          cuatrimestre_select: function () {
            this.$vs.loading();
            this.gethorario_cuatrimestre();
          }

        },
      components:{
        Button,
        Table,
        'v-select': vSelect
      },
        methods: {
      

           open_generar_horario(){
            this.$http.get("abrir_parametro_generar_horario").then(
                response => {
                  this.abrir_parametro_generar_horario = response.data;
                  // console.log(this.abrir_parametro_generar_horario);
                },
                error => {
                  this.StepError(error);
                }
            );
          },

        onChangeCarreraList:function(idc){
                
                if(idc>0){
                    this.carrera=idc;
                    this.gethorario_cuatrimestre();
                      this.getCuatrimestreSiguente();
                        
                }            

            },

      getCarreras(){
                this.$http.get("carreras").then(
                    response => {
                        this.carreras = response.data.carreras;
                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },
         printpage(){        
          
              let newstr = document.getElementById("printContent").innerHTML;

      window.onbeforeprint = function(event) {             
              };
              let oldstr = document.body.innerHTML;
              document.body.innerHTML = newstr;        
               window.print();
              document.body.innerHTML = oldstr;
              location.reload()
              return false;        
        },
      //setear el grupo a ngrupo select para la vsita
       onChangenGrupof:function (e) {      
                               this.nGrupof_text=e;
            },

          get_grupos_cuatrimestre_digito(){

            this.$http.get("grupos_cuatrimestre_digito/" + this.cuatrimestre_select.idDigito + "/" + this.cuatrimestre_select.idCuatrimestre + "/" + this.carrera + "/" + this.cuatrimestre_siguiente[0].idPeriodo + "/" + this.cuatrimestre_siguiente[0].idAgno).then(
                response => {
                  // console.log(response.data)
                  this.grupos_cuatrimestre_digito = response.data.grupos_cuatrimestre_digito;


                },
                error => {
                  this.StepError(error);
                }
            );

          },
          guardar_materia_horario(){


           let dia_elegido =  localStorage.getItem('dia_elegido');
            let hora_elegida =  localStorage.getItem('hora_elegida');

            this.$http.get("guardar_horario/" + this.cuatrimestre_select.idDigito + "/" + this.cuatrimestre_select.idCuatrimestre + "/" + this.grupo_select.idGrupo2 + "/" + dia_elegido + "/" + hora_elegida+"/"+this.grupo_select.idProfesor+ "/" + this.cuatrimestre_siguiente[0].idPeriodo + "/" + this.cuatrimestre_siguiente[0].idAgno).then(
                response => {
                             if(response.data.resultado==="ok"){ 
                                    this.$vs.notify({ color: 'success', title: 'Grupo asignado', text: 'Se ha asignado el grupo correctamente' })
                                    this.grupo_select={};
                                    this.popupActive=false;
                                    this.gethorario_cuatrimestre();
                                      
                                }else{
                                    this.$vs.notify({
                                        time: 2800,
                                        title: 'Nota-',
                                        text: response.data.resultado,
                                        iconPack: 'feather',
                                        icon: 'icon-alert-circle',
                                        color: 'danger'
                                    });
                                }

                                //aqui cerramos el poput

                },
                error => {
                  this.StepError(error);
                }
            );



          },
          quitar_materia_horario(){
            let dia_elegido =  localStorage.getItem('dia_elegido');
            let hora_elegida =  localStorage.getItem('hora_elegida');


            this.$http.get("quitar_horario/" + this.cuatrimestre_select.idDigito + "/" + this.cuatrimestre_select.idCuatrimestre + "/" + dia_elegido + "/" + hora_elegida+"/"+this.grupo_select.idProfesor+ "/" + this.cuatrimestre_siguiente[0].idPeriodo + "/" + this.cuatrimestre_siguiente[0].idAgno).then(
                response => {
                  this.popupActive=false;
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Grupo quitado',
                    text: 'Se ha quitado el grupo correctamente'
                  })
                  this.gethorario_cuatrimestre();

                },
                error => {
                  this.StepError(error);
                }
            );


          },
asignar_horario(dia, hora){
  this.popupActive=true;
   this.grupo_select={};


  localStorage.setItem('dia_elegido', dia)
  localStorage.setItem('hora_elegida', hora)

},
          get_clave(dia, hora){
       
            if(this.carrera>0){
            return this.tabla_horarios[hora + "" + dia].clave;
            }

          },
          getCuatrimestreSiguente(){
              
            this.$http.get("cuatrimestre_siguiente").then(
                response => {
                  this.cuatrimestre_siguiente = response.data.cuatrimestre_siguiente;
                  // this.$vs.loading.close();
                 this.getHoras();
                 this.getDias();

                },
                error => {
                  this.StepError(error);
                }
            );
          },
          gethorario_cuatrimestre(){
            this.$http.get("horario_cuatrimestre/" + this.cuatrimestre_select.idDigito + "/" + this.cuatrimestre_select.idCuatrimestre + "/" + this.carrera+ "/" + this.cuatrimestre_siguiente[0].idAgno + "/" + this.cuatrimestre_siguiente[0].idPeriodo).then(
                response => {
                  // console.log(response.data)
                  this.tabla_horarios = response.data.horario_cuatrimestre;
       
                  this.get_grupos_cuatrimestre_digito();
                  this.$vs.loading.close();

                },
                error => {
                  this.StepError(error);
                }
            );

          },
        getCuatrimestresDigitosSiguiente(){
    
          this.$http.get("cuatrimestres_digitos_periodo/" + this.carrera + "/" + this.cuatrimestre_siguiente[0].idAgno + "/" + this.cuatrimestre_siguiente[0].idPeriodo).then(
              response => {
                 if(!response.data.cuatrimestres_digitos_periodo[0].length){ 
                this.cuatrimestres_digitos_periodo = response.data.cuatrimestres_digitos_periodo;
                this.$vs.loading.close();
                this.gethorario_cuatrimestre();            
                     }else{
                      alert("benko No hay grupos asignados");                                   
                    }
                    
                  },
               error => {
                    alert("No hay grupos asignados");
                    this.StepError(error);
               }
            );

          this.$http.get("cuatrimestre_digito_periodo/" + this.carrera + "/" + this.cuatrimestre_siguiente[0].idAgno + "/" + this.cuatrimestre_siguiente[0].idPeriodo).then(
              response => {
                // !arr.length

               if(!response.data.cuatrimestre_digito_periodo[0].length){ 
                       this.cuatrimestre_select = response.data.cuatrimestre_digito_periodo[0];
                this.$vs.loading.close();
                     
                     }else{
                      // alert("No hay grupos asignados");
                      // this.$vs.loading.close();
                      
                      // console.log(response.data);
                                    
                    }


                ///fin del responce
                },
                error => {
                  this.StepError(error);
                }
              );


        },

        getHoras(){
            this.$http.get("horas_horarios").then(
                response => {
                  this.horas_horarios = response.data.horas_horarios;
                  this.$vs.loading.close();
                  this.getCuatrimestresDigitosSiguiente();

                },
                error => {
                  this.StepError(error);
                }
            );
          },
          getDias(){
            this.$http.get("dias_horarios").then(
                response => {
                  this.dias_horarios = response.data.dias_horarios;
                           this.$vs.loading.close();
                },
                error => {
                  this.StepError(error);
                }
            );
          },


        }
    }
</script>